import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Progress,
} from "reactstrap";

class AutoUpdateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateAvailable: false,
      updateInfo: null,
      downloading: false,
      downloadProgress: 0,
      updateDownloaded: false,
      updateError: null,
    };
  }

  componentDidMount() {
    if (window.electronAPI && window.electronAPI.updates) {
      // Listen for update available
      this.removeUpdateAvailableListener =
        window.electronAPI.updates.onUpdateAvailable((info) => {
          console.log("Renderer: update-available", info);
          this.setState({
            updateAvailable: true,
            updateInfo: info,
          });
        });

      // Listen for download progress
      this.removeUpdateProgressListener =
        window.electronAPI.updates.onUpdateProgress((progress) => {
          // console.log("Renderer: progress", progress);
          this.setState({
            downloading: true,
            downloadProgress: progress.percent,
          });
        });

      // Listen for update downloaded
      this.removeUpdateDownloadedListener =
        window.electronAPI.updates.onUpdateDownloaded((info) => {
          console.log("Renderer: update-downloaded", info);
          this.setState({
            downloading: false,
            updateDownloaded: true,
            updateAvailable: false,
            updateError: null,
          });
        });

      // Stop the progress state and show a recoverable error.
      this.removeUpdateErrorListener =
        window.electronAPI.updates.onUpdateError((error) => {
          console.error("Renderer: update-error", error);
          this.setState({
            downloading: false,
            updateAvailable: false,
            updateDownloaded: false,
            updateError: error || { message: "Không thể cập nhật ứng dụng." },
          });
        });
    }
  }

  componentWillUnmount() {
    if (this.removeUpdateAvailableListener)
      this.removeUpdateAvailableListener();
    if (this.removeUpdateProgressListener) this.removeUpdateProgressListener();
    if (this.removeUpdateDownloadedListener)
      this.removeUpdateDownloadedListener();
    if (this.removeUpdateErrorListener) this.removeUpdateErrorListener();
  }

  handleDownload = () => {
    if (window.electronAPI && window.electronAPI.updates) {
      window.electronAPI.updates.downloadUpdate();
      this.setState({
        downloading: true,
        updateAvailable: false,
        downloadProgress: 0,
        updateError: null,
      });
    }
  };

  handleInstall = () => {
    if (window.electronAPI && window.electronAPI.updates) {
      window.electronAPI.updates.installUpdate();
    }
  };

  handleClose = () => {
    this.setState({
      updateAvailable: false,
      downloading: false,
      downloadProgress: 0,
      updateDownloaded: false,
      updateError: null,
    });
  };

  handleOpenDownloadPage = () => {
    if (window.electronAPI && window.electronAPI.updates) {
      window.electronAPI.updates.openDownloadPage();
    }
  };

  render() {
    const {
      updateAvailable,
      updateInfo,
      downloading,
      downloadProgress,
      updateDownloaded,
      updateError,
    } = this.state;

    // 1. Update failed - stop progress and provide a manual bridge.
    if (updateError) {
      return (
        <Modal isOpen={true} backdrop="static" className="shadow-none mt-5">
          <ModalHeader className="text-danger">Cập nhật không thành công</ModalHeader>
          <ModalBody>
            <p>
              Không thể hoàn tất cập nhật tự động. Bạn có thể tải bộ cài mới
              nhất và cài thủ công, dữ liệu ứng dụng sẽ được giữ nguyên.
            </p>
            <small className="text-muted" style={{ wordBreak: "break-word" }}>
              {updateError.message || "Không thể cập nhật ứng dụng."}
            </small>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-end">
            <Button color="secondary" outline onClick={this.handleClose}>
              Đóng
            </Button>
            <Button
              color="primary"
              onClick={this.handleOpenDownloadPage}
              className="ml-2"
            >
              Tải bộ cài thủ công
            </Button>
          </ModalFooter>
        </Modal>
      );
    }

    // 2. Downloading Progress Modal
    if (downloading) {
      return (
        <Modal isOpen={true} backdrop="static" className="shadow-none mt-5">
          <ModalHeader>Đang tải cập nhật...</ModalHeader>
          <ModalBody>
            <div className="text-center mb-3">Vui lòng không tắt ứng dụng.</div>
            <Progress
              value={downloadProgress}
              animated
              color="primary"
              className="mb-2"
            />
            <div className="text-center">
              Downloading: {Math.round(downloadProgress)}%
            </div>
          </ModalBody>
        </Modal>
      );
    }

    // 3. Update Downloaded - Ready to Install
    if (updateDownloaded) {
      return (
        <Modal isOpen={true} backdrop="static" className="shadow-none mt-5">
          <ModalHeader className="text-success">Cập nhật hoàn tất</ModalHeader>
          <ModalBody>
            Phiên bản mới đã sẵn sàng. Bạn có muốn khởi động lại để cài đặt ngay
            bây giờ không?
          </ModalBody>
          <ModalFooter className="d-flex justify-content-end">
            <Button color="secondary" onClick={this.handleClose}>
              Để sau
            </Button>
            <Button
              color="success"
              onClick={this.handleInstall}
              className="ml-2"
            >
              Khởi động lại ngay
            </Button>
          </ModalFooter>
        </Modal>
      );
    }

    // 4. Update Available - Ask to Download
    return (
      <Modal
        isOpen={updateAvailable}
        backdrop="static"
        className="shadow-none mt-5"
      >
        <ModalHeader className="text-primary">Cập nhật phần mềm</ModalHeader>
        <ModalBody>
          <h5 className="mb-3">
            Phiên bản mới {updateInfo && updateInfo.version} đã sẵn sàng!
          </h5>
          <p>
            Phiên bản hiện tại của bạn đã cũ. Vui lòng cập nhật để trải nghiệm
            các tính năng mới nhất và sửa lỗi.
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" outline onClick={this.handleClose}>
            Để sau
          </Button>
          <Button
            color="primary"
            onClick={this.handleDownload}
            className="ml-2"
          >
            Tải xuống ngay
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AutoUpdateModal;
